module.exports = __webpack_public_path__ + "img/onboarding_update_profile_en.05577e27.png";